(function () {
  'use strict';

  function refreshCartSections() {
    // Delegerar till den gemensamma kon (cart-refresh.js) - den lokala kopian
    // hade dessutom en bugg: badgen lastes ur live-DOM i stallet for ur det
    // farska sektionssvaret, sa siffran kunde slapa ett steg.
    return window.SRCartRefresh ? window.SRCartRefresh.refresh() : Promise.resolve();
  }

  function addSample(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _sample: 'true' } }] })
    }).then(function (r) { return r.json(); });
  }

  function removeSample(variantId) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var line = cart.items.find(function (i) { return i.variant_id === variantId; });
        if (!line) return null;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: line.key, quantity: 0 })
        }).then(function (r) { return r.json(); });
      });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-cart-sample-input]');
    if (!input) return;
    var wrap = input.closest('[data-cart-sample]');
    if (!wrap) return;
    var variantId = parseInt(wrap.dataset.variantId, 10);
    if (!variantId) return;
    wrap.setAttribute('data-loading', 'true');
    input.disabled = true;
    var action = input.checked ? addSample(variantId) : removeSample(variantId);
    action
      .then(function () { return refreshCartSections(); })
      .catch(function () {})
      .then(function () {
        wrap.removeAttribute('data-loading');
        input.disabled = false;
      });
  });

  function triggerCtaFocus() {
    var targets = document.querySelectorAll('cart-drawer, .main-cart--outer');
    targets.forEach(function (t) {
      t.classList.remove('is-cta-focus');
      // force reflow so re-adding the class restarts the animation
      void t.offsetWidth;
      t.classList.add('is-cta-focus');
      setTimeout(function () { t.classList.remove('is-cta-focus'); }, 1400);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cart-sample-input-btn]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('[data-cart-sample]');
    if (!wrap) return;
    var variantId = parseInt(wrap.dataset.variantId, 10);
    if (!variantId) return;
    var isSelected = btn.getAttribute('aria-pressed') === 'true';
    var isAdding = !isSelected;
    wrap.setAttribute('data-loading', 'true');
    btn.disabled = true;
    var action = isAdding ? addSample(variantId) : removeSample(variantId);
    action
      .then(function () { return refreshCartSections(); })
      .then(function () { if (isAdding) triggerCtaFocus(); })
      .catch(function () {})
      .then(function () {
        wrap.removeAttribute('data-loading');
        btn.disabled = false;
      });
  });
})();
